const FILTRO_EMPTY = () => {
  return {
    numeroProcesso: '',
    nomeInteressado: '',
    cpfCnpjInteressado: '',
    municipio: [],
    nomeMunicipio: [],
    dataCadastro: null,
    simplificado: true,
    campoSimples: '',
    pagina: 0,
    ordem: 'id'
  }
}

export default FILTRO_EMPTY



// WEBPACK FOOTER //
// ./src/screens/bancoDados/models/filtroProcessoAntigo.js